import React, {useState, useContext} from 'react';
import {Box, Toolbar, Typography, Grid, Container, Paper} from '@mui/material';
import DashboardTile from '../../components/Tiles/DashboardTile';
import Copyright from '../../components/Common/Copyright';
import PillarTile from '../../components/Tiles/PillarTile';
import {Line} from 'recharts';
import StudentList from './StudentList';
import LineChartTile from '../../components/Charts/LineChartTile';
import BarChartTile from '../../components/Charts/BarChartTile';
import GlobalConstants from '../../components/GlobalConstants';
import {Context as DashboardContext} from '../../contexts/DashboardContext';

const objectToSortedArray = obj => {
  const array = Object.keys(obj)
    .map(key => {
      return {name: key, value: obj[key]};
    })
    .sort((a, b) => a.value < b.value);
  return array;
};

const objectToArray = obj => {
  const array = Object.keys(obj).map(key => {
    return {name: key, value: obj[key]};
  });

  return array;
};

const toReadable = key => {
  switch (key) {
    case 'total':
      return 'Total';
    case 'cashFlow':
      return 'Negative Cash Flow';
    case 'netWorth':
      return 'Negative Net Worth';
    case 'overdraft':
      return 'Overdraft';
    case 'creditDebt':
      return 'Credit Card Debt';
    case 'creditUtilization':
      return 'High Credit Utilization';
    case 'interest':
      return 'Interest';
    default:
      return key;
  }
};

const AtRiskDashboard = ({}) => {
  const {state} = useContext(DashboardContext);

  const {
    users,
    linked,
    atRisk,
    atRiskBreakdown,
    atRiskByDay,
    atRiskTransactionCategoriesPerMonth,
    atRiskTransactionTypesPerMonth,
    atRiskUsers,
    atRiskPillarBreakdown,
    averageAtRiskNetWorth,
  } = state;

  delete atRiskBreakdown.possible;
  delete atRiskBreakdown.new;
  const atRiskArray = objectToSortedArray(atRiskBreakdown);
  const array = Object.keys(atRiskBreakdown)
    .map(key => {
      return {name: toReadable(key), value: atRiskBreakdown[key]};
    })
    .sort((a, b) => a.value < b.value);

  return (
    <Box
      component="main"
      sx={{
        backgroundColor: '#fff',
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
        paddingTop: '60px',
        paddingBottom: '60px',
      }}>
      <Container maxWidth="lg" sx={{mt: 4, mb: 4}}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <StudentList data={atRiskUsers} count={atRisk} />
          </Grid>
          {/* CURRENT AT RISK */}
          <Grid item xs={12} md={12} lg={12}>
            <BarChartTile header="At Risk Students" data={array} />
          </Grid>
          {/* <Grid item xs={12} md={4} lg={3}>
              <Paper
                sx={{
                  p: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  height: 240,
                }}
                elevation={24}>
                <Deposits count={atRisk} header="At Risk" />              
              </Paper>
            </Grid> */}
          {/* TODO: uncomment once working again */}
          {/* <Grid item xs={12} md={12} lg={12}>
            <LineChartTile
              header="At Risk Students Over Time"
              data={breakdownByDay}
              legend={true}>
              <Line
                type="monotone"
                dataKey="total"
                stroke={GlobalConstants.COLORS[0]}
              />
              <Line
                type="monotone"
                dataKey="netWorth"
                stroke={GlobalConstants.COLORS[1]}
              />
              <Line
                type="monotone"
                dataKey="creditUtilization"
                stroke={GlobalConstants.COLORS[2]}
              />
              <Line
                type="monotone"
                dataKey="creditDebt"
                stroke={GlobalConstants.COLORS[3]}
              />
              <Line
                type="monotone"
                dataKey="cashFlow"
                stroke={GlobalConstants.COLORS[4]}
              />
              <Line
                type="monotone"
                dataKey="overdraft"
                stroke={GlobalConstants.COLORS[5]}
              />
              <Line
                type="monotone"
                dataKey="interest"
                stroke={GlobalConstants.COLORS[0]}
              />
            </LineChartTile>
          </Grid> */}
          {/* NET WORTH */}
          <Grid item xs={12} md={6} lg={4}>
            <DashboardTile
              bigContent={`$${averageAtRiskNetWorth.toFixed(2)}`}
              header="Average Net Worth"
              height={320}
            />
          </Grid>
          {/* PILLARS */}
          <PillarTile
            pillar={atRiskPillarBreakdown.checking}
            linked={atRisk}
            color={GlobalConstants.CHECKING}
            height={320}
          />
          <PillarTile
            pillar={atRiskPillarBreakdown.savings}
            linked={atRisk}
            color={GlobalConstants.SAVINGS}
            height={320}
          />
          <PillarTile
            pillar={atRiskPillarBreakdown.credit}
            linked={atRisk}
            color={GlobalConstants.CREDIT}
            height={320}
          />
          <PillarTile
            pillar={atRiskPillarBreakdown.debt}
            linked={atRisk}
            color={GlobalConstants.DEBT}
            height={320}
          />
          <PillarTile
            pillar={atRiskPillarBreakdown.investment}
            linked={atRisk}
            color={GlobalConstants.INVESTMENT}
            height={320}
          />
          {/* TRANSACTIONS BY MONTH */}
          <Grid item xs={12} md={12} lg={12}>
            <LineChartTile
              header="Transaction Category Breakdown by Month"
              data={atRiskTransactionCategoriesPerMonth}
              legend={true}>
              <Line
                type="monotone"
                dataKey="Transportation"
                stroke={GlobalConstants.COLORS[0]}
              />
              <Line
                type="monotone"
                dataKey="Food"
                stroke={GlobalConstants.COLORS[1]}
              />
              <Line
                type="monotone"
                dataKey="Living Expenses"
                stroke={GlobalConstants.COLORS[2]}
              />
            </LineChartTile>
          </Grid>

          {/* TRANSACTIONS BY MONTH */}
          <Grid item xs={12} md={12} lg={12}>
            <LineChartTile
              header="Transaction Types Per Month"
              data={atRiskTransactionTypesPerMonth}
              legend={true}>
              <Line
                type="monotone"
                dataKey="spending"
                stroke={GlobalConstants.COLORS[0]}
              />
              <Line
                type="monotone"
                dataKey="income"
                stroke={GlobalConstants.COLORS[1]}
              />
              <Line
                type="monotone"
                dataKey="savings"
                stroke={GlobalConstants.COLORS[2]}
              />
              <Line
                type="monotone"
                dataKey="investment"
                stroke={GlobalConstants.COLORS[3]}
              />
            </LineChartTile>
          </Grid>
        </Grid>
      </Container>
      <Copyright sx={{pt: 4}} />
    </Box>
  );
};

export default AtRiskDashboard;
